<template>
  <div class="contentBlock">
    <div class="header">
      <i class="icon"></i>
      <span class="title-text">{{ title }}</span>
    </div>
    <el-container>
      <div class="form">
        <el-form
          :inline="true"
          :model="ruleForm"
          class="demo-form-inline"
          :rules="rules"
          label-position="right"
          label-width="120px"
        >
          <el-form-item label="通知内容：" prop="content">
            <el-input
              type="textarea"
              v-model="ruleForm.content"
              maxlength="96"
              rows="5"
              cols="20"
              autoFocus
              placeholder="不超过96个字....."
              style="min-width: 600px"
            ></el-input> </el-form-item
          ><br />

          <el-form-item label="图片描述：">
            <el-upload
              class="avatar-uploader"
              action=""
              list-type="picture-card"
              :http-request="handleLicenseImgFileB"
              :show-file-list="true"
              :file-list="fileList"
              :limit="3"
              :auto-upload="false"
              :before-upload="beforeAvatarUpload"
              :on-remove="handleRemove"
              :on-preview="handlePictureCardPreview"
            >
              <i slot="default" class="el-icon-plus"></i>
              
            </el-upload>
            <el-dialog :visible.sync="dialogVisible" :modal-append-to-body="false">
  <img width="100%" :src="dialogImageUrl" alt="">
</el-dialog>
          </el-form-item><br/>

          <el-form-item label="处理人：">
            <el-select
                  v-model="ruleForm.operator"
                  clearable
                  style="min-width: 600px"
                >
                  <el-option
                    v-for="item in operatorArr"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  >
                  </el-option>
                </el-select></el-form-item
          ><br />

          <el-form-item label="">
            <router-link to="/announcement">
              <el-button class="cancel">取消</el-button>
            </router-link>
            <el-button type="primary" class="submit">提交</el-button>
            </el-form-item
          ><br />

        </el-form>
      </div>
    </el-container>
  </div>
</template>
<script>
import * as mUtils from "utils/mUtils";
import * as img from "@/api/img";
export default {
  data() {
    return {
      // 表单
      ruleForm: {
        content: "",
        operator: "",
        dealStatus: "",
        checkedTime: "",
        finishTime: "",
      },
      title: "新建通知",
      rules: {
        content: [
          { required: true, message: "请输入通知内容", trigger: "blur" },
        ],
      },
      headers: {},
      fileList: [
       
      ],
      operatorArr:[
        {id:"1",label:"张三"},
        {id:"2",label:"李四"},
        {id:"3",label:"王五"},
      ],
      dialogVisible: false,
      dialogImageUrl: '',
    };
  },
  created() {
    console.log(this.$route.query)
    if(this.$route.query.hasOwnProperty("name")){
      this.title = "查看通知";
    }
  },
  methods: {
    // 上传图片之前
    beforeAvatarUpload(file) {
      let isJPG = "";
      if (file.type === "image/jpeg") {
        isJPG = file.type === "image/jpeg";
      } else if (file.type === "image/png") {
        isJPG = file.type === "image/png";
      } else if (file.type === "image/gif") {
        isJPG = file.type === "image/gif";
      }

      const isLt2M = file.size / 1024 / 1024 < 4;

      if (!isJPG) {
        this.$message.error("上传图片只能是.jpeg,jpg,gif,png格式文件!");
      }

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 4MB!");
      }
      return isJPG && isLt2M;
    },

    // 上传图片
    handleLicenseImgFileB: function (file) {
      let that = this;
      var formData = new FormData();
      formData.append("file", file.file);
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      that.headers = {
        "Content-Type": "multipart/form-data",
      };
      img.upload(formData).then(function (res) {
        if (res.data.code != 0) {
          if (res.data.code == 1101) {
            let msg = res.data.msg;
            that.$message.error(msg);
          } else {
            that.$message.error("上传失败 !");
          }
          loading.close();
          return;
        } else {
          that.$message.success("上传成功 !");
          that.fileList.push({ url: res.data.data.data.path });

          loading.close();
        }
      });
    },

    // 移除图片
    handleRemove(file, fileList){

    },

    // 浏览大图
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      }
  },
};
</script>
<style  lang="less" scoped>
.contentBlock {
  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
  margin: 20px 50px 50px 30px;
  padding: 0 20px;
  .header {
    margin-bottom: 10px;
    border-bottom: 1px solid #708090;

    .icon {
      width: 10px;
      height: 25px;
      background: #2a7169;
      display: inline-block;
      margin: 5px 5px;
    }

    .title-text {
      display: inline-block;
      font-size: 28px;
      vertical-align: top;
      line-height: 32px;
      font-weight: 800;
    }
  }

  .form {
    margin-left: 100px;
  }
}
</style>
<style>
.el-form-item__label {
  font-size: 19px;
  font-weight: 100;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/* .el-upload--picture-card{
  display: none;
} */
.hide .el-upload--picture-card {
  display: none;
}
.submit{
  width:220px;margin-left:16px;
}
.cancel{
  width:220px;margin-left:120px;
}
</style>



// WEBPACK FOOTER //
// addEditComponent.vue?da57d61e